const ImageKitUrlPrefix = "https://ik.imagekit.io/albertine/";
const storyblokAmazonDomain = "https://s3.amazonaws.com/a.storyblok.com";
const storyblokCdnDomain = "https://a.storyblok.com";

// https://docs.imagekit.io/features/image-transformations
function transformImageKitUrl(
    url: string,
    options?: { height?: number; width?: number },
): string {
    const { height, width } = options ?? {};
    const urlParts = url.split("/");
    const filename = urlParts.pop();
    const path = urlParts.join("/");
    return `${path}/tr:f-avif${width ? `,w-${width}` : ""}${height ? `,h-${height}` : ""}/${filename}`;
}

export function cdnImage(
    filename: string,
    options?: { height?: number; width?: number },
) {
    if (filename.startsWith(ImageKitUrlPrefix)) {
        return transformImageKitUrl(filename, options);
    }

    if (
        !filename.startsWith(storyblokCdnDomain) &&
        !filename.startsWith(storyblokAmazonDomain)
    ) {
        return filename;
    }

    if (
        filename.includes(storyblokAmazonDomain) ||
        filename.includes(storyblokCdnDomain)
    ) {
        // https://www.storyblok.com/docs/image-service/#resizing
        const imageResize = options
            ? `${options.width ?? 0}x${options.height ?? 0}`
            : "";

        return `${filename.replace(
            storyblokAmazonDomain,
            storyblokCdnDomain,
        )}/m/${imageResize}`;
    }

    return filename;
}
